import React, {useContext, useEffect, useState} from 'react';
import { ExperiencePageContext } from './experiencePageContext.js';
import useProductsApi from '@/products/lib/useProductsApi.js';
import { AuthContext } from '@/auth/lib/authContext.js';
import { ExperienceContext } from '../../lib/experienceContext.js';
import usePersonaApi from '@/persona/lib/usePersonaApi.js';
import useExperienceApi from '../../lib/useExperienceApi.js';
export default function ExperiencePageProvider({children}) {
  const {
    experienceId,
    isFetchingPersonaList,
    isFetchingProductList,
    personaList,
    productList,
    refreshPersonaList,
    refreshProductList,
  } = useContext(ExperienceContext);
  const {profile} = useContext(AuthContext)
  const [isFetchingInsightList, setIsFetchingInsightList] = useState(false);
  const [insightList, setInsightList] = useState(null);
  const [isFetchingSharedExperienceList, setIsFetchingSharedExperienceList] = useState(false);
  const [sharedExperienceList, setSharedExperienceList] = useState(null);
  const [init, setInit] = useState(false);
  const experienceApi = useExperienceApi();

  useEffect(() => {
    if (experienceId && !init) {
      setInit(true);
      refreshSharedExperienceList();
    }
  }, [experienceId]);

  const refreshSharedExperienceList = async () => {
    try {
      setIsFetchingSharedExperienceList(true);
      const newSharedExperienceList = await experienceApi.fetchSharedExperiencesByExperienceId(experienceId);
      setSharedExperienceList((newSharedExperienceList ? newSharedExperienceList : []));
      setIsFetchingSharedExperienceList(false);
    } catch (error) {
      console.error('❌ Error loading shared experiences:', error);
      setIsFetchingSharedExperienceList(false);
    }
  }

  const refresh = async () => {
    try {
      await Promise.all([
        refreshPersonaList(),
        refreshProductList(),
        refreshSharedExperienceList(),
      ])
     ;
      ;
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <ExperiencePageContext.Provider value={{
      isFetchingPersonaList,
      isFetchingProductList,
      isFetchingInsightList,
      isFetchingSharedExperienceList,
      productList,
      personaList,
      insightList,
      sharedExperienceList,
      refresh: refresh,
      refreshProductList: refreshProductList,
      refreshPersonaList: refreshPersonaList,
      refreshSharedExperienceList: refreshSharedExperienceList
    }}>
      {children}
    </ExperiencePageContext.Provider>
  );
}